import React, { useState, useEffect } from "react";
import { server } from "../server";
import Swal from "sweetalert2";
import OtpModal from "../Templates/OtpModal";
import { decrypt } from "../data/decrypt";

function Registration() {
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const emailFromUrl = params.get("emailId") || "";
  
  setFormValue(prev => ({ ...prev, Email: emailFromUrl }));
  fetchCostCenters(emailFromUrl);
  fetchFacilities(emailFromUrl);
}, []);

  const fetchCostCenters = async (email) => {
    // alert(email);
    try {
      const res = await fetch(`${server}/api/Siemens/GetCostCenters`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ Email: email }),
      });
      const data = await res.json();
      setCostCenters(data.CostCenter || []);
    } catch (error) {
      console.error("Error fetching cost centers:", error);
    }
  };


  const fetchFacilities = async (email) => {
    
    try {
      const res = await fetch(`${server}/api/Siemens/GetFacilities`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ Email: email }),
      });
      const data = await res.json();
      setFacilities(data.Facilities || []);
    } catch (error) {
      console.error("Error fetching facilities:", error);
    }
  };

  const initialValues = {
    Name: "", Email: "", MobileNo: "", Gender: "", CostCenter: "", ProjectType: "",
    editable: "true", DeviceTokenId: "0", DeviceType: "Registration Web",
    UserPass: "", UserConfirmPass: "", CorporateId: "-1", CorporateName: "",
    VendorId: "2583", EmployeeID: "", CompanyId: "-1", OTP: "",Facility:"",EmployeeCode:""
  };

  const [formvalue, setFormValue] = useState({
    Name: "", Email: "", MobileNo: "", Gender: "",
    DeviceTokenId: "0", DeviceType: "Registration Web",
    UserPass: "", UserConfirmPass: "", CorporateId: "-1", CorporateName: "",
    VendorId: "2583", EmployeeID: "", CompanyId: "-1", OTP: "",Facility:""
  });

  const [showModal, setShowModal] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [costCenters, setCostCenters] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [projects, setProjects] = useState([]);

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setIsSubmit(false);
    setEnteredOTP(false);
  };

  const [SelectedCorporate, setSelectedCorporate] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);
  const [EnteredOTP, setEnteredOTP] = useState(false);

  const handChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formvalue, [name]: value });
    if (name === "CorporateId") {
      setSelectedCorporate(value);
    }
  };

  const verifyOtp = (otp) => {
    if (otp.length === 6) {
      setEnteredOTP(true);
      userRegistration({ ...formvalue, OTP: otp });
    } else {
      alert("Invalid OTP. Please enter a 6-digit code.");
    }
  };

  async function userRegistration(formvalue) {
    setIsRegistering(true);
    try {
      if (showModal === true) {
        formvalue.OTP = formvalue.OTP;
      } else {
        formvalue.OTP = "";
      }

      let result = await fetch(`${server}/api/Siemens/CorporateRegistrationEMS`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formvalue),
      });

      result = await result.json();

      if (result.statusCode == 200 && result.status === "Email/EmployeeId Already Exist") {
        Swal.fire("Invalid Input!", "Email/EmployeeId Already Exist", "error");
      } else if (result.statusMessage === "Mobile No. Already Exist") {
        Swal.fire("Error!", "Mobile No Already Registered", "error");
      } else if (result.status === "Invalid Email") {
        Swal.fire({
          icon: "warning",
          title: "Registration Required",
          html: `Your organization is not yet registered with us. 
                 Please contact your admin or reach out to us at 
                 <a href="https://refexmobility.com/business-commute/" target="_blank" style="color:#3085d6; text-decoration:underline;">
                   https://refexmobility.com/business-commute/
                 </a> to get started.`
        });
      } else if (result.status === "OTP Sent to Emaial") {
        openModal();
      } else if (result.status === "Invalid OTP") {
        Swal.fire("Error!", "Invalid OTP, please Enter a Valid OTP", "error");
      } else if (result.status === "Inserted Successfully") {
        Swal.fire("Success", "You're all set! Get ready for smoother, safer, and smarter travel with Refex.", "success");
        closeModal();
        setEnteredOTP(false);
        setIsSubmit(false);
        setFormValue(initialValues);
      }
    } catch (error) {
      Swal.fire("Network Error", "Something went wrong. Please try again later.", "error");
      console.error("Error during registration:", error);
    } finally {
      setIsRegistering(false);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(false);
    setFormErrors(validate(formvalue));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (
      Object.keys(formErrors).length === 0 &&
      IsSubmit &&
      EnteredOTP === false &&
      showModal === false
    ) {
      userRegistration(formvalue);
    }
  }, [formErrors]);

  const handleCostCenterChange = async (e) => {
    const { value } = e.target;
    setFormValue(prev => ({ ...prev, CostCenter: value }));
    try {
      const res = await fetch(`${server}/api/Siemens/GetProjectsByCostCenter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ CostCenterId: value }),
      });
      const data = await res.json();
      setProjects(data.data || data.projects || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const validate = (value) => {
    const errors = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const mobileNoRegex = /^[0-9]{10}$/;
    if (!value.Name) errors.Name = "Name is required";
    if (!value.Email) errors.Email = "Email required";
    else if (!emailRegex.test(value.Email)) errors.Email = "This is not a valid email format";
    if (!value.MobileNo) errors.MobileNo = "Mobile No. required";
    else if (!mobileNoRegex.test(value.MobileNo)) errors.MobileNo = "Invalid Mobile No.";
    if (!value.Gender) errors.Gender = "Gender required";
    if (!value.UserPass) errors.UserPass = "Password is required";
    else if (value.UserPass.length < 8) errors.UserPass = "Password must be at least 8 characters long";
    if (!value.UserConfirmPass) errors.UserConfirmPass = "Confirm password is required";
    if (value.UserPass && value.UserPass !== value.UserConfirmPass) errors.UserConfirmPass = "Passwords do not match";
    if (!value.Facility) errors.Facility = "Facility is required";
    if (!value.EmployeeCode) errors.EmployeeCode = "Employee Code is required";
    return errors;
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light px-3 py-4">
      <form onSubmit={handleSubmit} className="w-100" style={{ maxWidth: "420px" }}>

        <div className="card card-outline card-warning w-100">

          {/* Header */}
          <div className="card-header text-center py-3">
            <img
              src="/dist/img/Refexnewlogo.png"
              alt="logo"
              className="img-fluid"
              style={{ maxWidth: "150px", height: "70px", objectFit: "contain" }}
            />
          </div>

          {/* Body */}
          <div className="card-body px-3 px-sm-4">
            <p className="login-box-msg">
              {formvalue.editable == "false" ? "Create Password" : "Register"}
            </p>

            {/* Name */}
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="Name"
                value={formvalue.Name}
                onChange={(e) => {
                  const value = e.target.value.replace(/[0-9]/g, "");
                  handChange({ target: { name: "Name", value } });
                }}
                readOnly={(formvalue.Name != null && formvalue.Name !== "") && formvalue.editable == "false"}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-user" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.Name}</p>

            {/* Email */}
            <div className="input-group mb-2">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
                name="Email"
                value={formvalue.Email}
                onChange={handChange}
                readOnly={(formvalue.Email != null && formvalue.Email !== "") && formvalue.editable == "false"}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-envelope" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.Email}</p>

            {/* Mobile */}
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Mobile No"
                name="MobileNo"
                value={formvalue.MobileNo}
                readOnly={(formvalue.MobileNo != null && formvalue.MobileNo !== "") && formvalue.editable == "false"}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  if (value.length <= 10) {
                    handChange({ target: { name: "MobileNo", value } });
                  }
                }}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fa fa-mobile" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.MobileNo}</p>
            {/* Emp Code */}
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Employee Code"
                name="EmployeeCode"
                value={formvalue.EmployeeCode}
                onChange={handChange}
                readOnly={(formvalue.EmployeeCode != null && formvalue.EmployeeCode !== "") && formvalue.editable == "false"}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-user" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.EmployeeCode}</p>

            {/* Gender */}
            <div className="input-group mb-2">
              <select
                className="form-control"
                name="Gender"
                value={formvalue.Gender}
                disabled={(formvalue.Gender != null && formvalue.Gender !== "") && formvalue.editable == "false"}
                onChange={handChange}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              <span className="input-group-text">
                <i className="fas fa-venus-mars"></i>
              </span>
            </div>
            <p className="text-danger small mb-1">{formErrors.Gender}</p>
            <div className="input-group mb-2">
              <select
                className="form-control"
                name="Facility"
                value={formvalue.Facility}
                onChange={handChange}
              >
                <option value="">Select Facility</option>
                {facilities.map((item) => (
                  <option key={item.id} value={item.id}>{item.Facility_Name}</option>
                ))}
              </select>
              <span className="input-group-text">
                <i className="fas fa-sitemap"></i>
              </span>
            </div>
            <p className="text-danger small mb-1">{formErrors.Facility}</p>
            {/* Cost Center */}
            <div className="input-group mb-2">
              <select
                className="form-control"
                name="CostCenter"
                value={formvalue.CostCenter}
                onChange={handleCostCenterChange}
              >
                <option value="">Select Cost Center</option>
                {costCenters.map((item) => (
                  <option key={item.Id} value={item.Id}>{item.ProjectType}</option>
                ))}
              </select>
              <span className="input-group-text">
                <i className="fas fa-sitemap"></i>
              </span>
            </div>

            {/* Project */}
            <div className="input-group mb-2">
              <select
                className="form-control"
                name="ProjectType"
                value={formvalue.ProjectType}
                onChange={handChange}
              >
                <option value="">Select Project</option>
                {projects.map((item) => (
                  <option key={item.Id} value={item.Id}>{item.ProjectName}</option>
                ))}
              </select>
              <span className="input-group-text">
                <i className="fas fa-layer-group"></i>
              </span>
            </div>

            {/* Password */}
            <div className="input-group mb-2">
              <input
                type="password"
                className="form-control"
                placeholder="Create Password"
                name="UserPass"
                value={formvalue.UserPass}
                onChange={handChange}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-lock" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.UserPass}</p>

            {/* Confirm Password */}
            <div className="input-group mb-2">
              <input
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                name="UserConfirmPass"
                value={formvalue.UserConfirmPass}
                onChange={handChange}
              />
              <div className="input-group-append">
                <div className="input-group-text">
                  <span className="fas fa-lock" />
                </div>
              </div>
            </div>
            <p className="text-danger small mb-1">{formErrors.UserConfirmPass}</p>

            {/* Submit Button */}
            <div className="mt-3">
              <button
                className="btn btn-block w-100"
                style={{
                  backgroundColor: "#f4513b",
                  color: "#ffffff",
                  opacity: isRegistering ? "0.7" : "1",
                  cursor: isRegistering ? "not-allowed" : "pointer"
                }}
                disabled={isRegistering}
              >
                {isRegistering ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Registering...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>

            {/* OTP Modal */}
            <OtpModal
              show={showModal}
              handleClose={closeModal}
              verifyOtp={verifyOtp}
            />

          </div>
        </div>
      </form>
    </div>
  );
}

export default Registration;